import React, { Component } from "react";
import styled, { injectGlobal } from "styled-components";
import { connect } from "react-redux";

import {
  Background,
  WithPadding,
  FluidContainer,
  Container,
  ContainerWide
} from "../themes/Blocks";

import Theme from "../themes/appTheme";

import { doMainMenuToggle } from "../redux/reducers";

import Header from "./Header";
import Jumbo from "./Jumbo";

injectGlobal`
  html {
    font-size: 16px;
    @media (max-width: ${Theme.screen.medium}) {
      font-size: 14px;
    }
    @media (max-width: ${Theme.screen.mobile}) {
      font-size: 14px;
    }
  }
`;

class WelcomePage extends Component {
  render() {
    return (
      <Background color="purple">
        <Header />
        <FluidContainer className="fluid">
          <Jumbo />
        </FluidContainer>
      </Background>
    );
  }
}

const mapStateToProps = state => ({
  isMenuOpen: state.appState.mainMenu.open
});

const mapDispatchToProps = dispatch => ({
  onMainMenuToggle: () => dispatch(doMainMenuToggle())
});

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage);



// WEBPACK FOOTER //
// ./src/welcome-page/WelcomePage.js